import React, {
    Dispatch,
    FormEvent,
    SetStateAction
} from 'react'
import { getAuthUser } from '../../../helpers';
import { updateSupplierBrand, UpdateSupplierBrandParams, toastSuccess } from '../../../api'
import { SupplierBrand } from '../../../models'
import { SupplierBrandForm } from './form'
import defineAbilityFor from './defineAbility'
import { InsufficientPermissions } from '../../common';

interface EditSupplierBrandProps {
    supplierBrand: SupplierBrand
    setIsEditing: Dispatch<SetStateAction<boolean>>
    setSupplierBrand: Dispatch<SetStateAction<SupplierBrand | undefined>>
}

export const EditSupplierBrandForm = (props: EditSupplierBrandProps) => {
    const { supplierBrand, setIsEditing, setSupplierBrand } = props

    const ability = defineAbilityFor(getAuthUser())

    const handleSubmit = (e: FormEvent<HTMLFormElement>, inputs: UpdateSupplierBrandParams) => {
        e.preventDefault()

        updateSupplierBrand(supplierBrand.id.toString(), inputs)
            .then(json => {
                setSupplierBrand(new SupplierBrand(json.data))
                setIsEditing(false)
                toastSuccess('Supplier Brand Edited')
            })
            .catch(() => {})
    }

    if (!ability.can('Edit', 'SupplierBrand')) {
        return <InsufficientPermissions />
    }

    return (
        <SupplierBrandForm
            handleSubmit={handleSubmit}
            supplierBrand={supplierBrand} />
    )
}
